export default "__VITE_ASSET__BXP0RRC8__"